'use client';
import {
  useState,
  MouseEvent,
  useEffect,
  createContext,
  PropsWithChildren,
  useContext,
} from 'react';

export type position = {
  x: number;
  y: number;
};

type QuizHotSpotContextProps = {
  position: position;
  isActive: boolean;
  handleClick: (event: MouseEvent) => void;
  checkIsCorrect: () => boolean;
  setIsActive: (value: boolean) => void;
};

export const QuizHotSpotContext = createContext<QuizHotSpotContextProps>({
  position: { x: 0, y: 0 },
  isActive: false,
  /**
   * Handle clicking set position x,y .
   */
  handleClick: () => null,
  /**
   * Check is point in the area .
   */
  checkIsCorrect: () => false,
  /**
   * Set active after clicking .
   */
  setIsActive: () => null,
});

/**
 * QuizeHotSpotProvider.
 */
export const QuizHotSpotProvider = (props: PropsWithChildren): JSX.Element => {
  const { children } = props;
  const [position, setPosition] = useState<position>({ x: 0, y: 0 });
  const [isActive, setIsActive] = useState(false);
  const [targetID, setTargetID] = useState<string | null>(null);

  useEffect(() => {
    setIsActive(false);
    setPosition({ x: 0, y: 0 });
  }, [children]);

  const handleClick = (event: MouseEvent) => {
    const { offsetX, offsetY } = event.nativeEvent;
    setIsActive(true);
    setTargetID((event.target as HTMLTextAreaElement).id);
    setPosition({ x: offsetX, y: offsetY });
  };

  const checkIsCorrect = () => {
    if (targetID === 'hot-spot-area') {
      return true;
    } else {
      return false;
    }
  };

  return (
    <QuizHotSpotContext.Provider
      value={{
        position,
        isActive,
        setIsActive,
        handleClick,
        checkIsCorrect,
      }}
    >
      {children}
    </QuizHotSpotContext.Provider>
  );
};

/**
 * Retrieves the current QuizContext.
 */
export const useQuizHotSpotContext = (): QuizHotSpotContextProps =>
  useContext(QuizHotSpotContext);
